export const NAME = 'Sitemap';
